import React from 'react';

import styled from 'styled-components';

import { NwEditButton } from '@components/Gui/NwButton';

const Wrapper = styled.div`
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ProjectSummaryActionsCell = ({ row, onEditTransaction, preserveEmptySlot = true, ghost = false }) => {
    if (!onEditTransaction) {
        return preserveEmptySlot ? <Wrapper className="statement-actions">&nbsp;</Wrapper> : null;
    }

    return (
        <Wrapper className="statement-actions">
            <NwEditButton
                iconOnly
                onClick={(event) => {
                    event.stopPropagation();
                    onEditTransaction(row.Transaction || row);
                }}
            />
        </Wrapper>
    );
};

export default ProjectSummaryActionsCell;
